import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  collapsedContent: {
    margin: SPACES.xxs,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,
  },

  cell: {
    '&&': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },

  copyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 20,
      height: 20,
    },
  },
  copyIconSmall: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 15,
      height: 15,
    },
  },
}))
